export const MSAL_CACHE_ENCRYPTION_COOKIE_NAME = 'msal.cache.encryption';